import React, { useState, useEffect } from 'react';
import * as _ from 'lodash';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { isDataLoaded } from '../../types/data-providers';
import { SiteDataProvider } from '../../data/DataProviders/SiteDataProvider';
import { SiteCard } from '../SiteCard';
import { DataIndicators } from '../DataIndicators';

import { useSignalRData } from '../../data/DataProviders/SignalRDataProvider';
import { sortObjectArrayNaturally } from '../../lib';
import { SignalRLocation } from '../../types/signalr-types';
import { getUpdatedLocation } from '../../lib/signalr-helper';
import { useSiteAlarmListData } from '../../data/DataProviders/SiteAlarmListProvider';
import { useSelectedLocationData, isRecordFound } from '../../hooks/data-hooks';
import { SignalRSiteDataProvider } from '../../data/DataProviders/SignalRSiteDataProvider';
import { Footer } from '../Footer/Footer';

export const SiteCards: React.FC = () => {
    const selectedLocationData = useSelectedLocationData();
    const siteListData = useSiteAlarmListData();
    const { t } = useLanguageLocale();
    const signalRData = useSignalRData();
    const [alarmCount, setAlarmCount] = useState(0);

    const isEmpty =
        isDataLoaded(siteListData) &&
        (siteListData.value === undefined || (siteListData.value !== undefined && siteListData.value.length === 0));

    useEffect(() => {
        if (isDataLoaded(siteListData)) {
            if (isRecordFound(selectedLocationData) && signalRData.locations.length > 0) {
                const location: SignalRLocation | undefined = getUpdatedLocation(
                    signalRData.locations,
                    selectedLocationData.value.id
                );
                _.filter(location && location.sites, (site) => {
                    _.filter(siteListData.value, (exsitingSite) => {
                        if (site.alarmCount && site.alarmCount  !== null) {
                            if (site.siteId === exsitingSite.siteId && site.alarmCount !== null) {
                                exsitingSite.alarmCount = site.alarmCount;
                                setAlarmCount(exsitingSite.alarmCount);
                            }
                        } 
                    });
                });
            }
        }
    }, [signalRData, siteListData, alarmCount]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <DataIndicators
                errorMessage={t('DASHBOARD.SITE')}
                emptyMessage={t('DASHBOARD.SITE')}
                data={siteListData}
                emptyIcon="LocationCity"
                isEmpty={isEmpty}
                isDetailedInfo={true}
            />

            {isRecordFound(selectedLocationData) && isDataLoaded(siteListData) && siteListData.value.length > 0 && (
                <>
                    <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '48px', paddingRight: 48 }}>
                        {sortObjectArrayNaturally(siteListData.value, [
                            { sortField: 'alarmCount', sortOrder: 'DESC' },
                            { sortField: 'siteName' },
                        ]).map((site) => (
                            <SignalRSiteDataProvider
                                key={site.siteId}
                                siteId={site.siteId}
                                locationId={selectedLocationData.value.id}
                            >
                                <SiteDataProvider key={site.siteId} siteId={site.siteId}>
                                    <SiteCard
                                        locationId={selectedLocationData.value.id}
                                        id={site.siteId}
                                        name={site.siteName}
                                        alarmCount={site.alarmCount}
                                        deviceCount={site.deviceCount}
                                    />
                                </SiteDataProvider>
                            </SignalRSiteDataProvider>
                        ))}
                    </div>
                    <Footer text={t('DISCLAMIER.OVERVIEW')} />
                </>
            )}
        </>
    );
};
